import { CustomerModuleView } from '@Generated/back-office-client/src'
import { AlertDialog, Button, Flex } from '@radix-ui/themes'

type Props = {
  target: CustomerModuleView | null
  customerName: string
  onClose: () => void
  onConfirm: (mod: CustomerModuleView) => void
}

export const DisableConfirm = ({ target, customerName, onClose, onConfirm }: Props) => {
  return (
    <AlertDialog.Root open={!!target} onOpenChange={(open) => (!open ? onClose() : null)}>
      <AlertDialog.Content maxWidth="450px">
        <AlertDialog.Title>Disable {target?.name}</AlertDialog.Title>
        <AlertDialog.Description size="2">
          Disable {target?.name} for {customerName}? Users at this customer will lose access to this
          section on their next sign-in. Re-enabling restores it.
        </AlertDialog.Description>
        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray">
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <Button variant="solid" color="red" onClick={() => target && onConfirm(target)}>
            Disable module
          </Button>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}
